import styled from "styled-components";
import { transition } from "../../private/helpers";
var colorHelper = state => _ref => {
  var {
    theme,
    $variant,
    disabled
  } = _ref;
  var {
    palette
  } = theme;
  var standardColors = {
    primary: palette.linkPrimary,
    secondary: palette.linkSecondary,
    inline: palette.linkPrimary
  };
  var hoveredColors = {
    primary: palette.linkHoveredPrimary,
    secondary: palette.linkHoveredSecondary,
    inline: palette.linkHoveredPrimary
  };
  var pressedColors = {
    primary: palette.linkPressedPrimary,
    secondary: palette.linkPressedSecondary,
    inline: palette.linkPressedPrimary
  };
  if (disabled) return palette.textDisabled;else if (state === "hover") return hoveredColors[$variant];else if (state === "pressed") return pressedColors[$variant];else return standardColors[$variant];
};
var textDecorationHelper = state => _ref2 => {
  var {
    $variant,
    disabled
  } = _ref2;
  var standardTextDecorations = {
    primary: "none",
    secondary: "underline",
    inline: "underline"
  };
  if (disabled) return standardTextDecorations[$variant];else if (state === "hover") return "underline";else return standardTextDecorations[$variant];
};
var LinkBase = styled.a.withConfig({
  displayName: "LinkBase",
  componentId: "sc-12oy0hl-0"
})(["font-family:", ";font-weight:", ";text-decoration:", ";color:", ";transition:", ";@media (hover:hover){&:hover{text-decoration:", ";color:", ";cursor:", ";}}&:focus{outline:", ";border-radius:", ";outline-offset:0.125rem;}&:focus-visible{outline:", ";border-radius:", ";outline-offset:0.125rem;}&:focus:not(:focus-visible){outline:none;}&:active{color:", ";}"], _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.typography.body01.fontFamily;
}, _ref4 => {
  var {
    theme,
    $variant
  } = _ref4;
  return $variant === "secondary" ? "inherit" : theme.typography.strong.fontWeight;
}, textDecorationHelper(), colorHelper(), transition("color"), textDecorationHelper("hover"), colorHelper("hover"), _ref5 => {
  var {
    disabled
  } = _ref5;
  return disabled ? "not-allowed" : "pointer";
}, _ref6 => {
  var {
    theme
  } = _ref6;
  return theme.border.width.thick + " solid " + theme.palette.borderFocused;
}, _ref7 => {
  var {
    theme
  } = _ref7;
  return theme.border.radius.small;
}, _ref8 => {
  var {
    theme
  } = _ref8;
  return theme.border.width.thick + " solid " + theme.palette.borderFocused;
}, _ref9 => {
  var {
    theme
  } = _ref9;
  return theme.border.radius.small;
}, colorHelper("pressed"));
export default LinkBase;